/*
This list was pulled from Twilio's error codes file:
https://www.twilio.com/docs/api/errors/twilio-error-codes.json

The file has warning and error codes for _all_ of their products/APIs so the 
following `jq` commands will
1. filter out non-ERRORs
2. filter to only codes from the "Programmable SMS" and "Programmable Messaging" products
3. format the data to match our Bandwidth data

```
cat twilio-errors.json | \
  jq '[.[] | select(.log_level == "ERROR")]' | \
  jq '[.[] | select(.product == "Programmable SMS" or .product == "Programmable Messaging") | {code, message, description}]' | \
  jq 'reduce .[] as $item ({}; .[$item.code|tostring] = {code: $item.code|tostring, name: $item.message, description: $item.description | $item.message})'
```
*/
const twilioCodes: {
  [code: string]: {
    code: string;
    name: string;
    description: string;
  };
} = {
  "30111": {
    code: "30111",
    name: "Url is on a deny list",
    description: "Url is on a deny list",
  },
  "57016": {
    code: "57016",
    name: "'Topic' is empty",
    description: "'Topic' is empty",
  },
  "30118": {
    code: "30118",
    name: "Private key is invalid",
    description: "Private key is invalid",
  },
  "21725": {
    code: "21725",
    name: "Brand can only be updated when in FAILED state",
    description: "Brand can only be updated when in FAILED state",
  },
  "20504": {
    code: "20504",
    name: "Twilio Internal Error",
    description: "Twilio Internal Error",
  },
  "30006": {
    code: "30006",
    name: "Landline or unreachable carrier",
    description: "Landline or unreachable carrier",
  },
  "30117": {
    code: "30117",
    name: "Certificate cannot be parsed",
    description: "Certificate cannot be parsed",
  },
  "30107": {
    code: "30107",
    name: "Domain private certificate has not been uploaded",
    description: "Domain private certificate has not been uploaded",
  },
  "57013": {
    code: "57013",
    name: "'Topic' is absent",
    description: "'Topic' is absent",
  },
  "57020": {
    code: "57020",
    name: "Authorization failed",
    description: "Authorization failed",
  },
  "30019": {
    code: "30019",
    name: "Content size exceeds carrier limit",
    description: "Content size exceeds carrier limit",
  },
  "30884": {
    code: "30884",
    name: "Campaign vetting rejection - Spam/Phishing",
    description: "Campaign vetting rejection - Spam/Phishing",
  },
  "35133": {
    code: "35133",
    name: "Invalid 'Messages' array provided in the request",
    description: "Invalid 'Messages' array provided in the request",
  },
  "30043": {
    code: "30043",
    name: "International SMS via Domestic Gateway",
    description: "International SMS via Domestic Gateway",
  },
  "90009": {
    code: "90009",
    name: "The message SID already exists.",
    description: "The message SID already exists.",
  },
  "30758": {
    code: "30758",
    name: "Unknown Error Code",
    description: "Unknown Error Code",
  },
  "92008": {
    code: "92008",
    name: "Unsupported Content Type",
    description: "Unsupported Content Type",
  },
  "21660": {
    code: "21660",
    name: "Mismatch between the 'From' number and the account",
    description: "Mismatch between the 'From' number and the account",
  },
  "90007": {
    code: "90007",
    name: "Invalid validity period value",
    description: "Invalid validity period value",
  },
  "30124": {
    code: "30124",
    name: "MessagingServiceSID cannot be empty or null",
    description: "MessagingServiceSID cannot be empty or null",
  },
  "63016": {
    code: "63016",
    name: "Failed to send freeform message because you are outside the allowed window. If you are using WhatsApp, please use a Message Template.",
    description:
      "Failed to send freeform message because you are outside the allowed window. If you are using WhatsApp, please use a Message Template.",
  },
  "30897": {
    code: "30897",
    name: "Campaign vetting rejection - Disallowed Content",
    description: "Campaign vetting rejection - Disallowed Content",
  },
  "21654": {
    code: "21654",
    name: "ContentSid Required",
    description: "ContentSid Required",
  },
  "30409": {
    code: "30409",
    name: "This message cannot be canceled",
    description: "This message cannot be canceled",
  },
  "63036": {
    code: "63036",
    name: "The specified phone number cannot be reached using RCS at this time.",
    description:
      "The specified phone number cannot be reached using RCS at this time.",
  },
  "30119": {
    code: "30119",
    name: "Certificate and private key pair is invalid",
    description: "Certificate and private key pair is invalid",
  },
  "21606": {
    code: "21606",
    name: "The 'From' phone number provided is not a valid message-capable Twilio phone number for this destination/account",
    description:
      "The 'From' phone number provided is not a valid message-capable Twilio phone number for this destination/account",
  },
  "63031": {
    code: "63031",
    name: "Channels message cannot have same 'From' and 'To'",
    description: "Channels message cannot have same 'From' and 'To'",
  },
  "30447": {
    code: "30447",
    name: "Toll Free verification rejection - phone number not provisioned to Twilio",
    description:
      "Toll Free verification rejection - phone number not provisioned to Twilio",
  },
  "11751": {
    code: "11751",
    name: "Media Message - Media exceeds messaging provider size limit",
    description: "Media Message - Media exceeds messaging provider size limit",
  },
  "30444": {
    code: "30444",
    name: "Toll Free verification rejection - Disallowed: Fraud",
    description: "Toll Free verification rejection - Disallowed: Fraud",
  },
  "30474": {
    code: "30474",
    name: "Toll Free verification rejection - Need end business",
    description: "Toll Free verification rejection - Need end business",
  },
  "36005": {
    code: "36005",
    name: "Broadcast File Type Invalid",
    description: "Broadcast File Type Invalid",
  },
  "30440": {
    code: "30440",
    name: "Toll Free verification rejection - Unknown Error",
    description: "Toll Free verification rejection - Unknown Error",
  },
  "30036": {
    code: "30036",
    name: "Validity Period Expired",
    description: "Validity Period Expired",
  },
  "30121": {
    code: "30121",
    name: "Fallback URL is missing",
    description: "Fallback URL is missing",
  },
  "21611": {
    code: "21611",
    name: "This 'From' number has exceeded the maximum number of queued messages",
    description:
      "This 'From' number has exceeded the maximum number of queued messages",
  },
  "30901": {
    code: "30901",
    name: "Campaign rejection - The campaign registration request timed out.",
    description:
      "Campaign rejection - The campaign registration request timed out.",
  },
  "30749": {
    code: "30749",
    name: "Brand Registration Failure: Email address duplicate threshold reached",
    description:
      "Brand Registration Failure: Email address duplicate threshold reached",
  },
  "30027": {
    code: "30027",
    name: "US A2P 10DLC - T-Mobile Daily Message Limit Reached",
    description: "US A2P 10DLC - T-Mobile Daily Message Limit Reached",
  },
  "63008": {
    code: "63008",
    name: "Could not execute the request because the channel module has been misconfigured. Please check the Channel configuration in Twilio",
    description:
      "Could not execute the request because the channel module has been misconfigured. Please check the Channel configuration in Twilio",
  },
  "30011": {
    code: "30011",
    name: "MMS not supported by the receiving phone number in this region",
    description:
      "MMS not supported by the receiving phone number in this region",
  },
  "30130": {
    code: "30130",
    name: "Messaging Service SID already belongs in another domain configuration.",
    description:
      "Messaging Service SID already belongs in another domain configuration.",
  },
  "21627": {
    code: "21627",
    name: "Max Price must be a valid float",
    description: "Max Price must be a valid float",
  },
  "90014": {
    code: "90014",
    name: "Validity Period should be positive integer",
    description: "Validity Period should be positive integer",
  },
  "30888": {
    code: "30888",
    name: "Campaign vetting rejection - Age Gate Not Present / Not Acceptable",
    description:
      "Campaign vetting rejection - Age Gate Not Present / Not Acceptable",
  },
  "21736": {
    code: "21736",
    name: "Brand 2FA Failed",
    description: "Brand 2FA Failed",
  },
  "92005": {
    code: "92005",
    name: "ContentSid Required",
    description: "ContentSid Required",
  },
  "21408": {
    code: "21408",
    name: "Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number",
    description:
      "Permission to send an SMS or MMS has not been enabled for the region indicated by the 'To' number",
  },
  "35125": {
    code: "35125",
    name: "Maximum limit reached in the account for scheduling messages",
    description: "Maximum limit reached in the account for scheduling messages",
  },
  "21712": {
    code: "21712",
    name: "Phone Number or Short Code is associated with another Messaging Service.",
    description:
      "Phone Number or Short Code is associated with another Messaging Service.",
  },
  "30480": {
    code: "30480",
    name: "Toll-Free phone number verification rejection - Disallowed - Phishing",
    description:
      "Toll-Free phone number verification rejection - Disallowed - Phishing",
  },
  "30750": {
    code: "30750",
    name: "Brand Registration Failure: Mobile phone number duplicate threshold reached",
    description:
      "Brand Registration Failure: Mobile phone number duplicate threshold reached",
  },
  "30994": {
    code: "30994",
    name: "Campaign Registration Failed",
    description: "Campaign Registration Failed",
  },
  "57006": {
    code: "57006",
    name: "'EventType' is empty",
    description: "'EventType' is empty",
  },
  "63041": {
    code: "63041",
    name: "Template paused",
    description: "Template paused",
  },
  "30890": {
    code: "30890",
    name: "Campaign vetting rejection - Subscriber Help",
    description: "Campaign vetting rejection - Subscriber Help",
  },
  "57007": {
    code: "57007",
    name: "'EventType' is absent",
    description: "'EventType' is absent",
  },
  "30108": {
    code: "30108",
    name: "Twilio account does not belong to an organization",
    description: "Twilio account does not belong to an organization",
  },
  "57009": {
    code: "57009",
    name: "'EventType' is too long",
    description: "'EventType' is too long",
  },
  "30022": {
    code: "30022",
    name: "US A2P 10DLC - Rate Limits Exceeded",
    description: "US A2P 10DLC - Rate Limits Exceeded",
  },
  "30100": {
    code: "30100",
    name: "Domain SID is invalid",
    description: "Domain SID is invalid",
  },
  "30002": {
    code: "30002",
    name: "Account suspended",
    description: "Account suspended",
  },
  "63047": {
    code: "63047",
    name: "Link to a sample media file returned an invalid Content-Type",
    description: "Link to a sample media file returned an invalid Content-Type",
  },
  "30473": {
    code: "30473",
    name: "Toll Free verification rejection - Cannot validate business website URL",
    description:
      "Toll Free verification rejection - Cannot validate business website URL",
  },
  "30647": {
    code: "30647",
    name: "Failed to Upsert Contact",
    description: "Failed to Upsert Contact",
  },
  "92007": {
    code: "92007",
    name: "The Content Variables Parameter is invalid",
    description: "The Content Variables Parameter is invalid",
  },
  "216602": {
    code: "216602",
    name: "Content Type is not supported on this channel",
    description: "Content Type is not supported on this channel",
  },
  "21723": {
    code: "21723",
    name: "Campaign Verify token import already in progress",
    description: "Campaign Verify token import already in progress",
  },
  "30446": {
    code: "30446",
    name: "Toll Free verification rejection - Opt-in not sufficient: express consent required",
    description:
      "Toll Free verification rejection - Opt-in not sufficient: express consent required",
  },
  "30009": {
    code: "30009",
    name: "Missing inbound segment",
    description: "Missing inbound segment",
  },
  "63028": {
    code: "63028",
    name: "Number of parameters provided does not match the expected number of parameters",
    description:
      "Number of parameters provided does not match the expected number of parameters",
  },
  "30116": {
    code: "30116",
    name: "Certificate or private key or both are missing",
    description: "Certificate or private key or both are missing",
  },
  "21737": {
    code: "21737",
    name: "Campaign Registration Blocked for Non-Compliant Brand",
    description: "Campaign Registration Blocked for Non-Compliant Brand",
  },
  "30471": {
    code: "30471",
    name: "Toll Free verification rejection - High Risk - Non-secured URL in sample message",
    description:
      "Toll Free verification rejection - High Risk - Non-secured URL in sample message",
  },
  "21731": {
    code: "21731",
    name: "Cannot perform operation on suspended brand",
    description: "Cannot perform operation on suspended brand",
  },
  "63001": {
    code: "63001",
    name: "Channel could not authenticate the request. Please see Channel specific error message for more information",
    description:
      "Channel could not authenticate the request. Please see Channel specific error message for more information",
  },
  "30460": {
    code: "30460",
    name: "Toll Free verification rejection - Disallowed: Third Party Debt Collection",
    description:
      "Toll Free verification rejection - Disallowed: Third Party Debt Collection",
  },
  "90006": {
    code: "90006",
    name: "Invalid direction",
    description: "Invalid direction",
  },
  "30122": {
    code: "30122",
    name: "Fallback URL is invalid",
    description: "Fallback URL is invalid",
  },
  "57018": {
    code: "57018",
    name: "'Event' value type must be Map",
    description: "'Event' value type must be Map",
  },
  "57003": {
    code: "57003",
    name: "'Secret id' is invalid for this Partner",
    description: "'Secret id' is invalid for this Partner",
  },
  "36001": {
    code: "36001",
    name: "Broadcast SID Not Found",
    description: "Broadcast SID Not Found",
  },
  "30754": {
    code: "30754",
    name: "Brand Registration Failure: Invalid postal address",
    description: "Brand Registration Failure: Invalid postal address",
  },
  "20410": {
    code: "20410",
    name: "Gone",
    description: "Gone",
  },
  "30031": {
    code: "30031",
    name: "Invalid MaxRate",
    description: "Invalid MaxRate",
  },
  "57004": {
    code: "57004",
    name: "'Category' is empty",
    description: "'Category' is empty",
  },
  "30715": {
    code: "30715",
    name: "Vetting Token Not Allowed for Sole Proprietor Brands",
    description: "Vetting Token Not Allowed for Sole Proprietor Brands",
  },
  "30646": {
    code: "30646",
    name: "Failed to Upsert Consent",
    description: "Failed to Upsert Consent",
  },
  "36004": {
    code: "36004",
    name: "Error Retrieving File",
    description: "Error Retrieving File",
  },
  "30610": {
    code: "30610",
    name: "Message couldn't be delivered",
    description: "Message couldn't be delivered",
  },
  "21614": {
    code: "21614",
    name: "'To' number is not a valid mobile number",
    description: "'To' number is not a valid mobile number",
  },
  "63023": {
    code: "63023",
    name: "Channel generic error",
    description: "Channel generic error",
  },
  "21659": {
    code: "21659",
    name: "'From' is not a Twilio phone number or Short Code country mismatch",
    description:
      "'From' is not a Twilio phone number or Short Code country mismatch",
  },
  "30734": {
    code: "30734",
    name: "Brand Registration Failure: Sole Proprietor brands are not enabled",
    description:
      "Brand Registration Failure: Sole Proprietor brands are not enabled",
  },
  "30041": {
    code: "30041",
    name: "Message from an unregistered number sent to a United Kingdom number",
    description:
      "Message from an unregistered number sent to a United Kingdom number",
  },
  "30475": {
    code: "30475",
    name: "Toll Free verification rejection - Opt-in not sufficient: Cannot combine consent for messaging with requirement for service",
    description:
      "Toll Free verification rejection - Opt-in not sufficient: Cannot combine consent for messaging with requirement for service",
  },
  "30993": {
    code: "30993",
    name: "Campaign Registration Failed",
    description: "Campaign Registration Failed",
  },
  "30903": {
    code: "30903",
    name: "Campaign rejection - Incorrect Sole Prop Brand Registration",
    description: "Campaign rejection - Incorrect Sole Prop Brand Registration",
  },
  "30701": {
    code: "30701",
    name: "Brand Registration Failure: Invalid input parameters",
    description: "Brand Registration Failure: Invalid input parameters",
  },
  "21267": {
    code: "21267",
    name: "Alphanumeric Sender ID cannot be used as the 'From' number on trial accounts",
    description:
      "Alphanumeric Sender ID cannot be used as the 'From' number on trial accounts",
  },
  "21709": {
    code: "21709",
    name: "Alpha Sender ID is Invalid or Not Authorized for this Messaging Service",
    description:
      "Alpha Sender ID is Invalid or Not Authorized for this Messaging Service",
  },
  "21732": {
    code: "21732",
    name: "Campaign limit reached on the Brand",
    description: "Campaign limit reached on the Brand",
  },
  "30445": {
    code: "30445",
    name: "Toll Free verification rejection - Could not validate business information",
    description:
      "Toll Free verification rejection - Could not validate business information",
  },
  "21658": {
    code: "21658",
    name: "Parameter exceeded character limit",
    description: "Parameter exceeded character limit",
  },
  "21722": {
    code: "21722",
    name: "Invalid Campaign Verify token",
    description: "Invalid Campaign Verify token",
  },
  "21266": {
    code: "21266",
    name: "'To' and 'From' numbers cannot be the same",
    description: "'To' and 'From' numbers cannot be the same",
  },
  "63038": {
    code: "63038",
    name: "Account exceeded the daily messages limit",
    description: "Account exceeded the daily messages limit",
  },
  "30757": {
    code: "30757",
    name: "Brand Registration Failure: Missing Business Registration Number ",
    description:
      "Brand Registration Failure: Missing Business Registration Number ",
  },
  "30456": {
    code: "30456",
    name: "Toll Free verification rejection - Disallowed: SHAFT - Alcohol",
    description:
      "Toll Free verification rejection - Disallowed: SHAFT - Alcohol",
  },
  "63051": {
    code: "63051",
    name: "WhatsApp Business Account is Locked",
    description: "WhatsApp Business Account is Locked",
  },
  "57002": {
    code: "57002",
    name: "'Secret id' is too long",
    description: "'Secret id' is too long",
  },
  "63020": {
    code: "63020",
    name: "Twilio encountered a Business Manager account error",
    description: "Twilio encountered a Business Manager account error",
  },
  "63035": {
    code: "63035",
    name: "This operation is blocked because the RCS agent has not launched, the recipient has not accepted the invitation to become a tester, or the RCS sender only works in certain regions.",
    description:
      "This operation is blocked because the RCS agent has not launched, the recipient has not accepted the invitation to become a tester, or the RCS sender only works in certain regions.",
  },
  "63011": {
    code: "63011",
    name: "Invalid Request: Twilio encountered an error while processing your request",
    description:
      "Invalid Request: Twilio encountered an error while processing your request",
  },
  "11100": {
    code: "11100",
    name: "Invalid URL format",
    description: "Invalid URL format",
  },
  "92004": {
    code: "92004",
    name: "Invalid language code",
    description: "Invalid language code",
  },
  "30133": {
    code: "30133",
    name: "The certificate could not be uploaded.",
    description: "The certificate could not be uploaded.",
  },
  "21720": {
    code: "21720",
    name: "A2P Use Case is Invalid",
    description: "A2P Use Case is Invalid",
  },
  "57011": {
    code: "57011",
    name: "Unsupported Partner name",
    description: "Unsupported Partner name",
  },
  "30908": {
    code: "30908",
    name: "Campaign vetting rejection - Compliant Privacy Policy Required",
    description:
      "Campaign vetting rejection - Compliant Privacy Policy Required",
  },
  "21703": {
    code: "21703",
    name: "The Messaging Service does not have a phone number available to send a message",
    description:
      "The Messaging Service does not have a phone number available to send a message",
  },
  "30400": {
    code: "30400",
    name: "Parameters are not valid ",
    description: "Parameters are not valid ",
  },
  "21605": {
    code: "21605",
    name: "Maximum body length is 160 characters (old API endpoint)",
    description: "Maximum body length is 160 characters (old API endpoint)",
  },
  "21612": {
    code: "21612",
    name: 'Message cannot be sent with the current combination of "To" and/or "From" parameters',
    description:
      'Message cannot be sent with the current combination of "To" and/or "From" parameters',
  },
  "57017": {
    code: "57017",
    name: "'Topic' is too long",
    description: "'Topic' is too long",
  },
  "30463": {
    code: "30463",
    name: "Toll Free verification rejection - Disallowed: Stock Alerts/Platforms",
    description:
      "Toll Free verification rejection - Disallowed: Stock Alerts/Platforms",
  },
  "30895": {
    code: "30895",
    name: "Campaign vetting rejection - Direct Lending - Campaign and Content Attribute Error",
    description:
      "Campaign vetting rejection - Direct Lending - Campaign and Content Attribute Error",
  },
  "21635": {
    code: "21635",
    name: "'To' number cannot be a landline",
    description: "'To' number cannot be a landline",
  },
  "30729": {
    code: "30729",
    name: "Brand Registration Failure: Country code not allowed",
    description: "Brand Registration Failure: Country code not allowed",
  },
  "21619": {
    code: "21619",
    name: "A Message Body, Media URL or Content SID is required",
    description: "A Message Body, Media URL or Content SID is required",
  },
  "30007": {
    code: "30007",
    name: "Message filtered",
    description: "Message filtered",
  },
  "30896": {
    code: "30896",
    name: "Campaign vetting rejection - Opt-in Error",
    description: "Campaign vetting rejection - Opt-in Error",
  },
  "63006": {
    code: "63006",
    name: "Could not format given content for the channel. Please see Channel specific error message for more information",
    description:
      "Could not format given content for the channel. Please see Channel specific error message for more information",
  },
  "63029": {
    code: "63029",
    name: "The receiver failed to download the template",
    description: "The receiver failed to download the template",
  },
  "30906": {
    code: "30906",
    name: "Campaign Rejected by Twilio",
    description: "Campaign Rejected by Twilio",
  },
  "30713": {
    code: "30713",
    name: "Invalid Vetting Token",
    description: "Invalid Vetting Token",
  },
  "30040": {
    code: "30040",
    name: "Destination carrier requires Sender ID pre-registration",
    description: "Destination carrier requires Sender ID pre-registration",
  },
  "57021": {
    code: "57021",
    name: "Token invalid",
    description: "Token invalid",
  },
  "35126": {
    code: "35126",
    name: "The ScheduleType value provided is not supported for this channel",
    description:
      "The ScheduleType value provided is not supported for this channel",
  },
  "30038": {
    code: "30038",
    name: "OTP Message Body Filtered",
    description: "OTP Message Body Filtered",
  },
  "35111": {
    code: "35111",
    name: "SendAt timestamp is missing",
    description: "SendAt timestamp is missing",
  },
  "30103": {
    code: "30103",
    name: "Links not shortened due to application failure.",
    description: "Links not shortened due to application failure.",
  },
  "30907": {
    code: "30907",
    name: "Campaign vetting rejection - Website URL Validation Issue",
    description: "Campaign vetting rejection - Website URL Validation Issue",
  },
  "30902": {
    code: "30902",
    name: "Campaign rejection - A DCA2 rejected this campaign registration request.",
    description:
      "Campaign rejection - A DCA2 rejected this campaign registration request.",
  },
  "30404": {
    code: "30404",
    name: "Not Found",
    description: "Not Found",
  },
  "57005": {
    code: "57005",
    name: "'Category' is too long",
    description: "'Category' is too long",
  },
  "30129": {
    code: "30129",
    name: "Certificate is self signed",
    description: "Certificate is self signed",
  },
  "21730": {
    code: "21730",
    name: "System under maintenance. Please try again later.",
    description: "System under maintenance. Please try again later.",
  },
  "30127": {
    code: "30127",
    name: "MessagingServiceSID is invalid.",
    description: "MessagingServiceSID is invalid.",
  },
  "21902": {
    code: "21902",
    name: "InvoiceTag length must be between 0 and 32",
    description: "InvoiceTag length must be between 0 and 32",
  },
  "30441": {
    code: "30441",
    name: "Toll-Free phone number verification rejection - Disallowed: SHAFT - Sex",
    description:
      "Toll-Free phone number verification rejection - Disallowed: SHAFT - Sex",
  },
  "30128": {
    code: "30128",
    name: "MessagingServiceSidsAction is invalid",
    description: "MessagingServiceSidsAction is invalid",
  },
  "30710": {
    code: "30710",
    name: "Deleting a Brand with Active Campaigns is Not Allowed",
    description: "Deleting a Brand with Active Campaigns is Not Allowed",
  },
  "30044": {
    code: "30044",
    name: "Trial Message Length Exceeded",
    description: "Trial Message Length Exceeded",
  },
  "30037": {
    code: "30037",
    name: "Outbound Messaging Disabled",
    description: "Outbound Messaging Disabled",
  },
  "30465": {
    code: "30465",
    name: "Toll Free verification rejection - Disallowed: Risk Investment/Get Rich Quick Schemes",
    description:
      "Toll Free verification rejection - Disallowed: Risk Investment/Get Rich Quick Schemes",
  },
  "35127": {
    code: "35127",
    name: "'Messages' Body and ContentVariables cannot be provided together",
    description:
      "'Messages' Body and ContentVariables cannot be provided together",
  },
  "63045": {
    code: "63045",
    name: "Link to a sample media file returned an unexpected error status",
    description:
      "Link to a sample media file returned an unexpected error status",
  },
  "30032": {
    code: "30032",
    name: "Toll-Free Number Has Not Been Verified",
    description: "Toll-Free Number Has Not Been Verified",
  },
  "30797": {
    code: "30797",
    name: "Brand Registration Feedback: Non government entity registered as a government entity. Must be a U.S. government entity.",
    description:
      "Brand Registration Feedback: Non government entity registered as a government entity. Must be a U.S. government entity.",
  },
  "30885": {
    code: "30885",
    name: "Campaign vetting rejection - High Risk",
    description: "Campaign vetting rejection - High Risk",
  },
  "30894": {
    code: "30894",
    name: "Campaign vetting rejection - Invalid Brand Information",
    description: "Campaign vetting rejection - Invalid Brand Information",
  },
  "36009": {
    code: "36009",
    name: "Stats for Broadcast SID Not Found",
    description: "Stats for Broadcast SID Not Found",
  },
  "21910": {
    code: "21910",
    name: "Invalid 'From' and 'To' pair. 'From' and 'To' should be of the same channel",
    description:
      "Invalid 'From' and 'To' pair. 'From' and 'To' should be of the same channel",
  },
  "30620": {
    code: "30620",
    name: "Message couldn't be delivered",
    description: "Message couldn't be delivered",
  },
  "30702": {
    code: "30702",
    name: "Brand Registration Failure: Registration not found",
    description: "Brand Registration Failure: Registration not found",
  },
  "30991": {
    code: "30991",
    name: "Campaign Registration Failed",
    description: "Campaign Registration Failed",
  },
  "36008": {
    code: "36008",
    name: "Invalid Page Token",
    description: "Invalid Page Token",
  },
  "92009": {
    code: "92009",
    name: "The template associated with this SID has already been submitted for approval.",
    description:
      "The template associated with this SID has already been submitted for approval.",
  },
  "57019": {
    code: "57019",
    name: "'Authorization' header is missing or is invalid",
    description: "'Authorization' header is missing or is invalid",
  },
  "63025": {
    code: "63025",
    name: "Media already exists",
    description: "Media already exists",
  },
  "30883": {
    code: "30883",
    name: "Campaign vetting rejection - Content Violation",
    description: "Campaign vetting rejection - Content Violation",
  },
  "30442": {
    code: "30442",
    name: "Toll-Free phone number verification rejection - Disallowed: Spam",
    description:
      "Toll-Free phone number verification rejection - Disallowed: Spam",
  },
  "30021": {
    code: "30021",
    name: "Internal Failure with messaging service orchestrator",
    description: "Internal Failure with messaging service orchestrator",
  },
  "30485": {
    code: "30485",
    name: "Message couldn't be delivered",
    description: "Message couldn't be delivered",
  },
  "30123": {
    code: "30123",
    name: "Callback URL is missing",
    description: "Callback URL is missing",
  },
  "30892": {
    code: "30892",
    name: "Campaign vetting rejection - Invalid Sample Message - Public URL Shorteners",
    description:
      "Campaign vetting rejection - Invalid Sample Message - Public URL Shorteners",
  },
  "63022": {
    code: "63022",
    name: "Invalid vname certificate",
    description: "Invalid vname certificate",
  },
  "30751": {
    code: "30751",
    name: "Brand Registration Failure: Unsupported mobile phone number",
    description: "Brand Registration Failure: Unsupported mobile phone number",
  },
  "30891": {
    code: "30891",
    name: "Campaign vetting rejection - Invalid Website URL",
    description: "Campaign vetting rejection - Invalid Website URL",
  },
  "30024": {
    code: "30024",
    name: "Numeric Sender ID Not Provisioned on Carrier",
    description: "Numeric Sender ID Not Provisioned on Carrier",
  },
  "30029": {
    code: "30029",
    name: "Invalid ContentRetention",
    description: "Invalid ContentRetention",
  },
  "63009": {
    code: "63009",
    name: "Channel provider returned an internal service error (HTTP 5xx). Please see Channel specific error message for more information",
    description:
      "Channel provider returned an internal service error (HTTP 5xx). Please see Channel specific error message for more information",
  },
  "30114": {
    code: "30114",
    name: "Specified date is not available yet",
    description: "Specified date is not available yet",
  },
  "30003": {
    code: "30003",
    name: "Unreachable destination handset",
    description: "Unreachable destination handset",
  },
  "30455": {
    code: "30455",
    name: "Toll-Free phone number verification rejection - Disallowed: SHAFT - Hate",
    description:
      "Toll-Free phone number verification rejection - Disallowed: SHAFT - Hate",
  },
  "63003": {
    code: "63003",
    name: "Channel could not find To address",
    description: "Channel could not find To address",
  },
  "63043": {
    code: "63043",
    name: "Link to a sample media file returns 403 Forbidden",
    description: "Link to a sample media file returns 403 Forbidden",
  },
  "36003": {
    code: "36003",
    name: "Broadcast Upload File Size Exceeded",
    description: "Broadcast Upload File Size Exceeded",
  },
  "35117": {
    code: "35117",
    name: "Scheduling does not support this timestamp",
    description: "Scheduling does not support this timestamp",
  },
  "35134": {
    code: "35134",
    name: "`Messages` array contains duplicate `To` numbers.",
    description: "`Messages` array contains duplicate `To` numbers.",
  },
  "21655": {
    code: "21655",
    name: "The ContentSid is Invalid",
    description: "The ContentSid is Invalid",
  },
  "30034": {
    code: "30034",
    name: "US A2P 10DLC - Message from an Unregistered Number",
    description: "US A2P 10DLC - Message from an Unregistered Number",
  },
  "63007": {
    code: "63007",
    name: "Twilio could not find a Channel with the specified 'From' address",
    description:
      "Twilio could not find a Channel with the specified 'From' address",
  },
  "36007": {
    code: "36007",
    name: "Broadcast Upload Status Check Failure",
    description: "Broadcast Upload Status Check Failure",
  },
  "30796": {
    code: "30796",
    name: "Brand Registration Feedback: Non public entity registered as a public for profit entity or the stock information mismatch.",
    description:
      "Brand Registration Feedback: Non public entity registered as a public for profit entity or the stock information mismatch.",
  },
  "30470": {
    code: "30470",
    name: "Toll Free verification rejection - High Risk: Deceptive Marketing",
    description:
      "Toll Free verification rejection - High Risk: Deceptive Marketing",
  },
  "30476": {
    code: "30476",
    name: "Toll Free verification rejection - Opt-in not provided",
    description: "Toll Free verification rejection - Opt-in not provided",
  },
  "30990": {
    code: "30990",
    name: "Campaign Suspension",
    description: "Campaign Suspension",
  },
  "30436": {
    code: "30436",
    name: "Invalid Phone Number SID",
    description: "Invalid Phone Number SID",
  },
  "30452": {
    code: "30452",
    name: "Toll-Free phone number verification unable to process - email invalid",
    description:
      "Toll-Free phone number verification unable to process - email invalid",
  },
  "30020": {
    code: "30020",
    name: "Internal Failure with Message Scheduling",
    description: "Internal Failure with Message Scheduling",
  },
  "30450": {
    code: "30450",
    name: "Message delivery blocked",
    description: "Message delivery blocked",
  },
  "30010": {
    code: "30010",
    name: "Message price exceeds max price",
    description: "Message price exceeds max price",
  },
  "21610": {
    code: "21610",
    name: "Attempt to send to unsubscribed recipient",
    description: "Attempt to send to unsubscribed recipient",
  },
  "90001": {
    code: "90001",
    name: "Message SID is invalid",
    description: "Message SID is invalid",
  },
  "21717": {
    code: "21717",
    name: "Brand Registration SID for US A2P Campaign Use Case is Not Registered or Not Valid",
    description:
      "Brand Registration SID for US A2P Campaign Use Case is Not Registered or Not Valid",
  },
  "30793": {
    code: "30793",
    name: "Brand Registration Failure: Validation problems with connected bundles",
    description:
      "Brand Registration Failure: Validation problems with connected bundles",
  },
  "30468": {
    code: "30468",
    name: "Toll Free verification rejection - Disallowed: Third-party Lead Generation",
    description:
      "Toll Free verification rejection - Disallowed: Third-party Lead Generation",
  },
  "30748": {
    code: "30748",
    name: "Brand Registration Failure: Phone number duplicate threshold reached",
    description:
      "Brand Registration Failure: Phone number duplicate threshold reached",
  },
  "30992": {
    code: "30992",
    name: "Campaign Registration Failed",
    description: "Campaign Registration Failed",
  },
  "30451": {
    code: "30451",
    name: "Toll-Free phone number verification unable to process - address invalid",
    description:
      "Toll-Free phone number verification unable to process - address invalid",
  },
  "57001": {
    code: "57001",
    name: "'Secret id' is empty",
    description: "'Secret id' is empty",
  },
  "30454": {
    code: "30454",
    name: "Account exceeded the messages limit",
    description: "Account exceeded the messages limit",
  },
  "92002": {
    code: "92002",
    name: "The 'variables' parameter exceeds the allowed limit",
    description: "The 'variables' parameter exceeds the allowed limit",
  },
  "30457": {
    code: "30457",
    name: "Toll Free verification rejection - Disallowed: SHAFT - Firearms",
    description:
      "Toll Free verification rejection - Disallowed: SHAFT - Firearms",
  },
  "90031": {
    code: "90031",
    name: "Broadcast Recipients list is empty [deprecated] ",
    description: "Broadcast Recipients list is empty [deprecated] ",
  },
  "30467": {
    code: "30467",
    name: "Toll Free verification rejection - Disallowed: Credit Repair",
    description: "Toll Free verification rejection - Disallowed: Credit Repair",
  },
  "63019": {
    code: "63019",
    name: "Media failed to download",
    description: "Media failed to download",
  },
  "30798": {
    code: "30798",
    name: "Brand Registration Feedback: No IRS 501c tax-exempt status found.",
    description:
      "Brand Registration Feedback: No IRS 501c tax-exempt status found.",
  },
  "30461": {
    code: "30461",
    name: "Toll Free verification rejection - Disallowed: Gambling",
    description: "Toll Free verification rejection - Disallowed: Gambling",
  },
  "30893": {
    code: "30893",
    name: "Campaign vetting rejection - Inconsistency between Sample Message and Use-case",
    description:
      "Campaign vetting rejection - Inconsistency between Sample Message and Use-case",
  },
  "30115": {
    code: "30115",
    name: "Date format is incorrect",
    description: "Date format is incorrect",
  },
  "35118": {
    code: "35118",
    name: "MessagingServiceSid is required to schedule a message",
    description: "MessagingServiceSid is required to schedule a message",
  },
  "21652": {
    code: "21652",
    name: "Maximum subject length is 40 characters",
    description: "Maximum subject length is 40 characters",
  },
  "30469": {
    code: "30469",
    name: "Toll Free verification rejection - Disallowed: Illegal substances/articles",
    description:
      "Toll Free verification rejection - Disallowed: Illegal substances/articles",
  },
  "30753": {
    code: "30753",
    name: "Brand Registration Failure: Unsupported email address",
    description: "Brand Registration Failure: Unsupported email address",
  },
  "30008": {
    code: "30008",
    name: "Unknown error",
    description: "Unknown error",
  },
  "30448": {
    code: "30448",
    name: "Toll-Free phone number verification rejection - Age Gate",
    description: "Toll-Free phone number verification rejection - Age Gate",
  },
  "30042": {
    code: "30042",
    name: "The Sender ID is blocked as generic or it contains special characters",
    description:
      "The Sender ID is blocked as generic or it contains special characters",
  },
  "63021": {
    code: "63021",
    name: "Channel invalid content error",
    description: "Channel invalid content error",
  },
  "21624": {
    code: "21624",
    name: "Invalid validity period value",
    description: "Invalid validity period value",
  },
  "30449": {
    code: "30449",
    name: "Toll Free verification rejection - URL issues in sample message",
    description:
      "Toll Free verification rejection - URL issues in sample message",
  },
  "30790": {
    code: "30790",
    name: "Brand Registration Failure: Internal system error",
    description: "Brand Registration Failure: Internal system error",
  },
  "30459": {
    code: "30459",
    name: "Toll Free verification rejection - Disallowed: Cannabis/CBD",
    description: "Toll Free verification rejection - Disallowed: Cannabis/CBD",
  },
  "30795": {
    code: "30795",
    name: "Brand Registration Feedback: Data mismatch related to tax id and its associated properties.",
    description:
      "Brand Registration Feedback: Data mismatch related to tax id and its associated properties.",
  },
  "30437": {
    code: "30437",
    name: "Toll Free verification rejection - Edit time expired",
    description: "Toll Free verification rejection - Edit time expired",
  },
  "63034": {
    code: "63034",
    name: "Media exceeds size limit",
    description: "Media exceeds size limit",
  },
  "30126": {
    code: "30126",
    name: "Your 10DLC number failed to be registered ",
    description: "Your 10DLC number failed to be registered ",
  },
  "57014": {
    code: "57014",
    name: "'Event' data in payload is absent",
    description: "'Event' data in payload is absent",
  },
  "30887": {
    code: "30887",
    name: "Campaign vetting rejection - Opt-out Error",
    description: "Campaign vetting rejection - Opt-out Error",
  },
  "21657": {
    code: "21657",
    name: "The Sender ID is invalid ",
    description: "The Sender ID is invalid ",
  },
  "30880": {
    code: "30880",
    name: "Campaign vetting rejection - Unknown Error",
    description: "Campaign vetting rejection - Unknown Error",
  },
  "63018": {
    code: "63018",
    name: "Rate limit exceeded for Channel",
    description: "Rate limit exceeded for Channel",
  },
  "30899": {
    code: "30899",
    name: "Campaign rejection - The campaign registration failed because of carrier rejection(s).",
    description:
      "Campaign rejection - The campaign registration failed because of carrier rejection(s).",
  },
  "92001": {
    code: "92001",
    name: "'Types' Parameter Required",
    description: "'Types' Parameter Required",
  },
  "30001": {
    code: "30001",
    name: "Queue overflow",
    description: "Queue overflow",
  },
  "30120": {
    code: "30120",
    name: " Domain certificate and private key are not uploaded",
    description: " Domain certificate and private key are not uploaded",
  },
  "30113": {
    code: "30113",
    name: "Specified date is too old",
    description: "Specified date is too old",
  },
  "30023": {
    code: "30023",
    name: "US A2P 10DLC - Daily Message Cap Reached",
    description: "US A2P 10DLC - Daily Message Cap Reached",
  },
  "63012": {
    code: "63012",
    name: "Channel provider returned an internal service error",
    description: "Channel provider returned an internal service error",
  },
  "57022": {
    code: "57022",
    name: "Required header is missing or invalid",
    description: "Required header is missing or invalid",
  },
  "30905": {
    code: "30905",
    name: "Campaign Review Pending by Twilio",
    description: "Campaign Review Pending by Twilio",
  },
  "36006": {
    code: "36006",
    name: "Broadcast Cannot Be Canceled",
    description: "Broadcast Cannot Be Canceled",
  },
  "30479": {
    code: "30479",
    name: "Toll Free verification rejection - justification needed for more than five toll free phone numbers per businesses",
    description:
      "Toll Free verification rejection - justification needed for more than five toll free phone numbers per businesses",
  },
  "30886": {
    code: "30886",
    name: "Campaign vetting rejection - Invalid Campaign Description",
    description: "Campaign vetting rejection - Invalid Campaign Description",
  },
  "57008": {
    code: "57008",
    name: "'EventType' format must be String",
    description: "'EventType' format must be String",
  },
  "30882": {
    code: "30882",
    name: "Campaign vetting rejection - Terms & Conditions",
    description: "Campaign vetting rejection - Terms & Conditions",
  },
  "21729": {
    code: "21729",
    name: "Cannot perform operation on suspended campaign",
    description: "Cannot perform operation on suspended campaign",
  },
  "21719": {
    code: "21719",
    name: "Incompatible Messaging Service/A2P Use Cases",
    description: "Incompatible Messaging Service/A2P Use Cases",
  },
  "21724": {
    code: "21724",
    name: "Brand update count exceeded",
    description: "Brand update count exceeded",
  },
  "63027": {
    code: "63027",
    name: "Template does not exist for a language and locale",
    description: "Template does not exist for a language and locale",
  },
  "30132": {
    code: "30132",
    name: "Certificate cannot be validated. ",
    description: "Certificate cannot be validated. ",
  },
  "30464": {
    code: "30464",
    name: "Toll Free verification rejection - Disallowed: Cryptocurrency",
    description:
      "Toll Free verification rejection - Disallowed: Cryptocurrency",
  },
  "30410": {
    code: "30410",
    name: "Provider Timeout Error",
    description: "Provider Timeout Error",
  },
  "63005": {
    code: "63005",
    name: "Channel did not accept given content. Please see Channel specific error message for more information",
    description:
      "Channel did not accept given content. Please see Channel specific error message for more information",
  },
  "30752": {
    code: "30752",
    name: "Brand Registration Failure: Invalid or expired OTP",
    description: "Brand Registration Failure: Invalid or expired OTP",
  },
  "35132": {
    code: "35132",
    name: "Bulk : Provided Attributes JSON is not valid",
    description: "Bulk : Provided Attributes JSON is not valid",
  },
  "63013": {
    code: "63013",
    name: "Channel policy violation",
    description: "Channel policy violation",
  },
  "21268": {
    code: "21268",
    name: "Sending to Premium rate or Information Service numbers is not allowed",
    description:
      "Sending to Premium rate or Information Service numbers is not allowed",
  },
  "30472": {
    code: "30472",
    name: "Toll Free verification rejection - Could not verify Business",
    description: "Toll Free verification rejection - Could not verify Business",
  },
  "30135": {
    code: "30135",
    name: "Unable to issue certificate",
    description: "Unable to issue certificate",
  },
  "30898": {
    code: "30898",
    name: "Campaign vetting rejection - Excessive EIN  ",
    description: "Campaign vetting rejection - Excessive EIN  ",
  },
  "30017": {
    code: "30017",
    name: "Carrier network congestion",
    description: "Carrier network congestion",
  },
  "30028": {
    code: "30028",
    name: "Invalid API version",
    description: "Invalid API version",
  },
  "21713": {
    code: "21713",
    name: "Messaging Service Use Case is Invalid",
    description: "Messaging Service Use Case is Invalid",
  },
  "21265": {
    code: "21265",
    name: "'To' number cannot be a Short Code",
    description: "'To' number cannot be a Short Code",
  },
  "30030": {
    code: "30030",
    name: "Invalid AddressRetention",
    description: "Invalid AddressRetention",
  },
  "30500": {
    code: "30500",
    name: "Twilio Internal Error",
    description: "Twilio Internal Error",
  },
  "21603": {
    code: "21603",
    name: "A 'From' or 'MessagingServiceSid' parameter is required to send a message",
    description:
      "A 'From' or 'MessagingServiceSid' parameter is required to send a message",
  },
  "57010": {
    code: "57010",
    name: "'PartnerName' is absent",
    description: "'PartnerName' is absent",
  },
  "63030": {
    code: "63030",
    name: "Unsupported parameter for type of channels message",
    description: "Unsupported parameter for type of channels message",
  },
  "30904": {
    code: "30904",
    name: "Campaign Not Shared with Twilio",
    description: "Campaign Not Shared with Twilio",
  },
  "14107": {
    code: "14107",
    name: "SMS send rate limit exceeded",
    description: "SMS send rate limit exceeded",
  },
  "63002": {
    code: "63002",
    name: "Channel could not find the From address",
    description: "Channel could not find the From address",
  },
  "30791": {
    code: "30791",
    name: "Brand Registration Failure: Temporary system error",
    description: "Brand Registration Failure: Temporary system error",
  },
  "30794": {
    code: "30794",
    name: "US A2P Registration: General error",
    description: "US A2P Registration: General error",
  },
  "30889": {
    code: "30889",
    name: "Campaign vetting rejection - Embedded Phone Number",
    description: "Campaign vetting rejection - Embedded Phone Number",
  },
  "30109": {
    code: "30109",
    name: "Callback URL is invalid",
    description: "Callback URL is invalid",
  },
  "21656": {
    code: "21656",
    name: "The ContentVariables Parameter is invalid",
    description: "The ContentVariables Parameter is invalid",
  },
  "57012": {
    code: "57012",
    name: "Signature invalid",
    description: "Signature invalid",
  },
  "30478": {
    code: "30478",
    name: "Toll Free verification rejection - single phone number used for multiple businesses",
    description:
      "Toll Free verification rejection - single phone number used for multiple businesses",
  },
  "30102": {
    code: "30102",
    name: "TLS certificate for your Domain has expired.",
    description: "TLS certificate for your Domain has expired.",
  },
  "63015": {
    code: "63015",
    name: "Channel Sandbox can only send messages to phone numbers that have joined the Sandbox",
    description:
      "Channel Sandbox can only send messages to phone numbers that have joined the Sandbox",
  },
  "92006": {
    code: "92006",
    name: "The Content Sid is Invalid",
    description: "The Content Sid is Invalid",
  },
  "63040": {
    code: "63040",
    name: "Template Rejected",
    description: "Template Rejected",
  },
  "63032": {
    code: "63032",
    name: "We cannot send this message to this user because of a WhatsApp limitation. ",
    description:
      "We cannot send this message to this user because of a WhatsApp limitation. ",
  },
  "30909": {
    code: "30909",
    name: "Campaign vetting rejection - CTA Verification Issue",
    description: "Campaign vetting rejection - CTA Verification Issue",
  },
  "30443": {
    code: "30443",
    name: "Toll-Free verification rejection - Disallowed: Loan Marketing",
    description:
      "Toll-Free verification rejection - Disallowed: Loan Marketing",
  },
  "30759": {
    code: "30759",
    name: "US A2P Registration: Insufficient Permissions to Perform Operation",
    description:
      "US A2P Registration: Insufficient Permissions to Perform Operation",
  },
  "30005": {
    code: "30005",
    name: "Unknown destination handset",
    description: "Unknown destination handset",
  },
  "30462": {
    code: "30462",
    name: "Toll Free verification rejection - Disallowed: Sweepstakes",
    description: "Toll Free verification rejection - Disallowed: Sweepstakes",
  },
  "30110": {
    code: "30110",
    name: "Domain is blocked",
    description: "Domain is blocked",
  },
  "35114": {
    code: "35114",
    name: "Scheduling does not support this timestamp",
    description: "Scheduling does not support this timestamp",
  },
  "63024": {
    code: "63024",
    name: "Invalid message recipient",
    description: "Invalid message recipient",
  },
  "21704": {
    code: "21704",
    name: "The Messaging Service contains no phone numbers",
    description: "The Messaging Service contains no phone numbers",
  },
  "30136": {
    code: "30136",
    name: "Unable to renew certificate",
    description: "Unable to renew certificate",
  },
  "21721": {
    code: "21721",
    name: "Cannot import Campaign Verify token due to incompatible A2P brand",
    description:
      "Cannot import Campaign Verify token due to incompatible A2P brand",
  },
  "30703": {
    code: "30703",
    name: "Brand Registration Failure: Duplicate record detected",
    description: "Brand Registration Failure: Duplicate record detected",
  },
  "30799": {
    code: "30799",
    name: "Brand Registration Feedback: We were unable to verify the details of the registration data.",
    description:
      "Brand Registration Feedback: We were unable to verify the details of the registration data.",
  },
  "30033": {
    code: "30033",
    name: "US A2P 10DLC - Campaign Suspended",
    description: "US A2P 10DLC - Campaign Suspended",
  },
  "11206": {
    code: "11206",
    name: "HTTP protocol violation",
    description: "HTTP protocol violation",
  },
  "63033": {
    code: "63033",
    name: "Recipient opted out to receive message",
    description: "Recipient opted out to receive message",
  },
  "63042": {
    code: "63042",
    name: "Template disabled",
    description: "Template disabled",
  },
  "30712": {
    code: "30712",
    name: "Brand Registration Failure: Max registration limit reached",
    description: "Brand Registration Failure: Max registration limit reached",
  },
  "30134": {
    code: "30134",
    name: "Invalid Dns Setup for Link shortening",
    description: "Invalid Dns Setup for Link shortening",
  },
  "30466": {
    code: "30466",
    name: "Toll Free verification rejection - Disallowed - Debt Reduction",
    description:
      "Toll Free verification rejection - Disallowed - Debt Reduction",
  },
  "21661": {
    code: "21661",
    name: "'From' number is not SMS-capable",
    description: "'From' number is not SMS-capable",
  },
  "63010": {
    code: "63010",
    name: "Twilio's platform encountered an internal error processing this message",
    description:
      "Twilio's platform encountered an internal error processing this message",
  },
  "21728": {
    code: "21728",
    name: "Campaign registration failed due to length validation failures",
    description:
      "Campaign registration failed due to length validation failures",
  },
  "30756": {
    code: "30756",
    name: "Brand Registration Failure: Obfuscation check failure",
    description: "Brand Registration Failure: Obfuscation check failure",
  },
  "63017": {
    code: "63017",
    name: "Rate limit exceeded",
    description: "Rate limit exceeded",
  },
  "30747": {
    code: "30747",
    name: "Brand Registration Failure: Address duplicate threshold reached",
    description:
      "Brand Registration Failure: Address duplicate threshold reached",
  },
  "30035": {
    code: "30035",
    name: "US A2P 10DLC - Message from a number still being configured",
    description: "US A2P 10DLC - Message from a number still being configured",
  },
  "92003": {
    code: "92003",
    name: "'language' Parameter Required",
    description: "'language' Parameter Required",
  },
  "30881": {
    code: "30881",
    name: "Campaign vetting rejection - Invalid Brand Support Email",
    description: "Campaign vetting rejection - Invalid Brand Support Email",
  },
  "30615": {
    code: "30615",
    name: "Message couldn't be delivered",
    description: "Message couldn't be delivered",
  },
  "21727": {
    code: "21727",
    name: "Campaign registration failed due to missing parameter(s)",
    description: "Campaign registration failed due to missing parameter(s)",
  },
  "63026": {
    code: "63026",
    name: "Channel sender content flagged as spam",
    description: "Channel sender content flagged as spam",
  },
  "30458": {
    code: "30458",
    name: "Toll Free verification rejection - Disallowed: SHAFT - Tobacco / Vape",
    description:
      "Toll Free verification rejection - Disallowed: SHAFT - Tobacco / Vape",
  },
  "30755": {
    code: "30755",
    name: "Brand Registration Failure: Unsupported country code",
    description: "Brand Registration Failure: Unsupported country code",
  },
  "21714": {
    code: "21714",
    name: "Messaging Service Number Pool size limit reached",
    description: "Messaging Service Number Pool size limit reached",
  },
  "36002": {
    code: "36002",
    name: "Broadcast Request Limit Reached",
    description: "Broadcast Request Limit Reached",
  },
  "63044": {
    code: "63044",
    name: "Link to a sample media file returns 404 Not Found",
    description: "Link to a sample media file returns 404 Not Found",
  },
  "30792": {
    code: "30792",
    name: "Brand Registration Failure: General error",
    description: "Brand Registration Failure: General error",
  },
  "30900": {
    code: "30900",
    name: "Campaign rejection - The campaign use case is ineligible for registration.",
    description:
      "Campaign rejection - The campaign use case is ineligible for registration.",
  },
  "63049": {
    code: "63049",
    name: "Meta chose not to deliver this WhatsApp marketing message",
    description: "Meta chose not to deliver this WhatsApp marketing message",
  },
  "30004": {
    code: "30004",
    name: "Message blocked",
    description: "Message blocked",
  },
  "21715": {
    code: "21715",
    name: "Phone Number Does Not Have Correct Messaging Service Capabilities",
    description:
      "Phone Number Does Not Have Correct Messaging Service Capabilities",
  },
  "63039": {
    code: "63039",
    name: "Warning! Facebook says your page is engaging in behavior that may be considered bothersome or abusive by users. To avoid messaging restrictions being placed on your Page, Facebook requires you to immediately decrease the rate at which you are sending messages outside the 24-hour window to this person.",
    description:
      "Warning! Facebook says your page is engaging in behavior that may be considered bothersome or abusive by users. To avoid messaging restrictions being placed on your Page, Facebook requires you to immediately decrease the rate at which you are sending messages outside the 24-hour window to this person.",
  },
  "30453": {
    code: "30453",
    name: "Message couldn't be delivered",
    description: "Message couldn't be delivered",
  },
  "30477": {
    code: "30477",
    name: "Toll Free verification rejection - Opt-in - Third party information sharing not allowed",
    description:
      "Toll Free verification rejection - Opt-in - Third party information sharing not allowed",
  },
  "30106": {
    code: "30106",
    name: "Domain has not been set up for this account",
    description: "Domain has not been set up for this account",
  },
  "21726": {
    code: "21726",
    name: "Starter brand registrations and updates are temporarily disabled",
    description:
      "Starter brand registrations and updates are temporarily disabled",
  },
  "35115": {
    code: "35115",
    name: "Scheduling does not support this timestamp",
    description: "Scheduling does not support this timestamp",
  },
  "30101": {
    code: "30101",
    name: "Domain is unverified",
    description: "Domain is unverified",
  },
  "30630": {
    code: "30630",
    name: "Attempt to send to unsubscribed recipient",
    description: "Attempt to send to unsubscribed recipient",
  },
  "63014": {
    code: "63014",
    name: "Channel message blocked by user action",
    description: "Channel message blocked by user action",
  },
};

export default twilioCodes;
